import React from 'react';
import { CircularProgress } from '@mui/material';

export const Spinner = () => {
    return <CircularProgress />;
};